import React from 'react';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, CloseButton } from 'react-bootstrap';
import xlsx from "json-as-xlsx"


export const Informe = ({ nombre, csv, pdf, spinner, origen = 'Congregacion', tipoInforme = 'Listado simple', xls = true }) => {

    const download_csv = async () => {
        spinner(true)
        const data = await csv();
        const b = new Blob([data]);
        const url = URL.createObjectURL(b);
        const a = document.createElement("a");
        a.href = url;
        a.download = nombre.split(" ").join("_") + '.csv';
        document.body.appendChild(a);
        a.click();
        setTimeout(function () {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        }, 0);
    }

    const download_xlsx = async () => {
        spinner(true)
        //pido los datos
        const data2 = await csv()
//console.log(data2)
        //monto estructura de datos        
        let miData = [{}]
        //nombre de la hoja dentro del libro
        miData[0].sheet = 'Hojica'
        //titulo columnas dentro de la hoja con filtro de campos y agrupaciones que no me interesan

        miData[0].columns = Object.keys(data2[0]).filter(f=> f !== 'id' && f !== 'sisterId' && f !== 'provinceId' && f !== 'communityId' && f !== 'userId' && f !== 'tuplas' && f !== 'cargos'  && f !== 'votos' && f !== 'laicos').map(item => {
            return { label: item.toUpperCase(), value: item }
        })
        //contenido de la hoja
        miData[0].content = data2.map((item) => {
            return item
        })

       // console.log('miData')
       // console.log(miData)
        let settings = {
            fileName: nombre.split(" ").join("-"), // Name of the resulting spreadsheet
            extraLength: 3, // A bigger number means that columns will be wider
            writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
            writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
            RTL: false, // Display the columns from right-to-left (the default value is false)
        }

        xlsx(miData, settings) // Will download the excel file
        spinner(false)

        
        /*
        //console.log('data2')
       //console.log(data2)
   //console.log('map')
   //console.log(data2.map((item) => {delete item.cargos 
    //   return item}).filter(f => f.sisterId === 610))
        miData[0].columns = Object.keys(data2[0]).map(item => {
           return {label:item, value:item}
       }).filter(f => f.label !== 'cargos')
       //contenido de la hoja
       miData[0].content = data2.map((item) => {delete item.cargos 
           return item}).filter(f => f.sisterId === 610)

       let data = [
           {
             sheet: "Adults",
             columns: [
               { label: "User", value: "user" }, // Top level data
               { label: "Age", value: (row) => row.age + " years" }, // Custom format
               { label: "Phone", value: (row) => (row.more ? row.more.phone || "" : "") }, // Run functions
             ],
             content: [
               { user: "Andrea", age: 20, more: { phone: "11111111" } },
               { user: "Luis", age: 21, more: { phone: "12345678" } },
             ],
           },
         ]
         console.log('date ejemplo')
         console.log(data)
*/
       
    }

    const generatePDF = async () => {
        spinner(true)
        await pdf(origen, tipoInforme)
        spinner(false)
    }

    return (
        <tr>
            <td>{nombre}</td>
            <td>{csv && <Button variant="outline-info" onClick={xls ? download_xlsx : download_csv}>{xls ? 'XLSX' : 'CSV'}</Button>}</td>
            <td>{pdf && <Button variant="outline-info" onClick={generatePDF}>PDF</Button>}</td>

        </tr>
    )
}

Informe.propTypes = {
    nombre: PropTypes.string.isRequired,
    csv: PropTypes.func,
    pdf: PropTypes.func,
    origen: PropTypes.func,
    //102022 para poder quitar los botones
    //csv: PropTypes.func.isRequired,
    //pdf: PropTypes.func.isRequired
}